<template>
  <div class="barrage-container">
    <canvas ref="canvasContainer"
            class="canvasContainer"
            :width="barrageWidth"
            :height="barrageHeight"
            style="display: none;"></canvas>
    <div class="container" :style="{height: barrageHeight+'px'}">
      <canvas id="canvas"
              class="canvas1"
              ref="canvas"
              :width="barrageWidth"
              :height="barrageHeight"
              :style="{'width': barrageWidth + 'px',
                       'height': barrageHeight + 'px'}"></canvas>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  let animFrame
  const fontSize = {
    'fs-s': {
      font: '22px Microsoft YaHei',
      size: 22
    },
    'fs-m': {
      font: '24px Microsoft YaHei',
      size: 24
    },
    'fs-x': {
      font: '26px Microsoft YaHei',
      size: 26
    },
    'fs-xl': {
      font: '28px Microsoft YaHei',
      size: 28
    },
    'fs-xll': {
      font: '30px Microsoft YaHei',
      size: 30
    },
  }
  export default {
    name: 'Barrage',
    props: {
      barrageList: {
        type: Array,
        default: () => []
      },
      speed: {
        type: Number,
        default: 4
      },
      loop: {
        type: Boolean,
        default: true
      },
      channels: {
        type: Number,
        default: 2
      },
      font: {
        type: String,
        default: '26px Microsoft YaHei',
      },
      borderColor: {
        type: String,
        default: '#F65676'
      },
      background: {
        type: String,
        default: '#FFFFFF'
      },
      linearGradient: {
        type: Object,
        default: () => {
          return {
            startColor: '',
            endColor: ''
          }
        }
      },
      // winWidth: {
      //   type: String,
      //   default: '#FFFFFF'
      // },
    },
    data () {
      return {
        barrageArray: [],
        barrageQueue: [],
        barrageWidth: 0,
        barrageHeight: 0,
        channelsArray: [],
        waitArray: [],
        // bwm: 1.5,   // barrageWidthMulti
        bwm: 1,   // barrageWidthMulti

        cg: 38,     // channelGap：轨道间距
        rgw: 300,    // rectGapWidth：矩形间空白间隙
        rpli: 16,   // rectPaddingLeftWithIcon：有icon时，矩形内padding-left间隙
        rpr: 26,    // rectPaddingRight：矩形内padding-right间隙
        rH: 60,     // rectHeight：矩形高度
        ibr: 40,    // iconBgRadius：icon背景圆形半径
        ir: 35,     // iconRadius：icon图片半径
        fontSize: 26,
        fontWeight: '',
        renderFont: '',

        crownImgUrl: 'https://image-weddinglive.marryou520.com/pc/crown.png',
        crownImg: new Image(),
      }
    },
    computed: {
      ...mapState(['win', 'globalFont']),
    },
    watch: {
      barrageList (val) {
        // if (val.length !== 0) {
        this.barrageQueue = val
        this.barrageArray = []
        this.waitArray = []
        this.initData()
        window.cancelAnimationFrame(animFrame)
        animFrame = window.requestAnimationFrame(this.render)
        // }
      },
      win (val) {
        this.initBarrage()
        // this.initData()
      },
      'globalFont.size' (val) {
        // console.log(val)
        this.updateSize(val)
      },
      'globalFont.bold' (val) {
        // console.log(val)
        this.updateWeight(val)
      }
    },
    created () {
      const globalFont = this.globalFont
      const data = fontSize[globalFont.size]
      this.fontSize = data.size
      this.fontWeight = globalFont.bold ? 'bold ' : ''
      this.renderFont = this.fontWeight + data.font
    },
    mounted () {
      this.initBarrage()
    },
    methods: {
      /**
       * 数据初始化
       */
      initBarrage () {
        this.barrageWidth = document.body.clientWidth
        // this.barrageWidth = document.body.clientWidth * 2
        this.barrageHeight = this.channels * 150
        this.ctx = this.$refs.canvas.getContext('2d')
        this.ctx1 = this.$refs.canvasContainer.getContext('2d')
      },
      initData () {
        this.crownImg.src = this.crownImgUrl
        const ratio = 26 / this.fontSize
        for (let i = 0; i < this.barrageQueue.length; i++) { // 此处处理只显示50个字符
          let content = this.dealStr(this.barrageQueue[i].content)
          let tempIcon = this.barrageQueue[i].icon
          let icon = null
          if (typeof tempIcon === 'object' && tempIcon instanceof Image) {
            icon = tempIcon
          }
          if (typeof tempIcon === 'string') {
            let img = new Image()
            img.src = tempIcon
            icon = img
          }
          this.ctx1.font = this.renderFont
          let contentWidth = this.ctx1.measureText(content).width
          this.barrageArray.push({
            id: this.barrageQueue[i].id,
            content: content,
            x: this.bwm * this.barrageWidth,
            icon: icon,
            baseWidth: contentWidth * ratio,
            width: contentWidth + this.ibr * 2 + this.rpli + this.rpr,
            color: this.barrageQueue[i].color || '#2F2F2F',
            identifyName: this.barrageQueue[i].identifyName,
          })
        }
        this.initChannel()
      },
      /**
       * 初始化轨道数据
       */
      initChannel () {
        for (let i = 0; i < this.channels; i++) {
          let item = this.barrageArray.shift()
          this.waitArray.push(item)
          if (item) {
            this.channelsArray[i] = [item]
          } else {
            this.channelsArray[i] = []
          }
        }
      },
      updateSize (val) {
        const data = fontSize[val]
        const size = data.size
        this.fontSize = size
        this.renderFont = this.fontWeight + data.font
        const ratio = size / 26
        let diff = (ratio > 1 ? -10 : 10) * (26 / size)
        if (ratio === 1) diff = 0
        for (let i = 0; i < this.waitArray.length; i++) { // 此处处理只显示50个字符
          let contentWidth = this.waitArray[i].baseWidth
          this.waitArray[i].width = (contentWidth + this.ibr * 2 + this.rpli + this.rpr) * ratio + diff
        }

        for (let i = 0; i < this.channelsArray.length; i++) {
          for (let j = 0; j < this.channelsArray[i].length; j++) {
            const channel = this.channelsArray[i][j]
            let contentWidth = channel.baseWidth
            channel.width = (contentWidth + this.ibr * 2 + this.rpli + this.rpr) * ratio + diff
          }
        }
      },
      updateWeight (val) {
        this.fontWeight = (val ? 'bold ' : '')
        this.renderFont = this.fontWeight + this.fontSize + 'px Microsoft YaHei'
      },
      /**
       * 渲染
       */
      render () {
        this.ctx.clearRect(0, 0, this.barrageWidth, this.barrageHeight)
        this.ctx.font = this.renderFont
        this.draw()
        animFrame = window.requestAnimationFrame(this.render)
      },
      draw () {
        for (let i = 0; i < this.channelsArray.length; i++) {
          for (let j = 0; j < this.channelsArray[i].length; j++) {
            try {
              let barrage = this.channelsArray[i][j]
              barrage.x -= this.speed
              if (barrage.x <= this.bwm * this.barrageWidth) {
                let itemY = i * (this.rH + this.cg)+ 20
                if (barrage.icon) {
                  this.circleBorder(this.ctx, barrage.icon, barrage.x, itemY, this.ibr, this.ir)
                }
                this.borderColor && this.drawRoundRectBorder(this.ctx, barrage.x, itemY, barrage.width, this.rH, this.rH / 2)
                this.drawRoundRect(this.ctx, barrage.x, itemY, barrage.width, this.rH, this.rH / 2)
                this.ctx.fillStyle = `${barrage.color}`
                this.ctx.fillText(barrage.content, barrage.x + this.ibr * 2 + this.rpli, itemY + 40)
                if (barrage.icon) {
                  this.circleImg(this.ctx, barrage.icon, barrage.x, itemY, this.ibr, this.ir)
                }
                if(barrage.identifyName){
                  this.drawIdentify(this.ctx, barrage.identifyName, barrage.x, itemY, )
                }
              }

              if (barrage.x < -(barrage.width + this.bwm * this.barrageWidth)) {
                let item = this.channelsArray[i].shift()
                item.x = this.barrageWidth
                if (this.loop) {
                  let arr = this.channelsArray.reduce((a, b) => a.concat(b))
                  if (arr.length === 0) {
                    this.barrageQueue = []
                    this.barrageQueue = this.waitArray
                    this.waitArray = []
                    this.initData()
                  }
                }
              }

              if (barrage.x <= (this.bwm * this.barrageWidth - barrage.width - this.rgw)
                && barrage.x >= (this.bwm * this.barrageWidth - barrage.width - this.rgw - this.speed)
                && (j === this.channelsArray[i].length - 1)
                && this.barrageArray.length !== 0) {
                  let item = this.barrageArray.shift()
                  this.channelsArray[i].push(item)
                  this.waitArray.push(item)
              }
            } catch (e) {
              console.log(e)
            }
          }
        }
      },
      /**
       * 重置数据
       */
      add (obj) {
        let content = this.dealStr(obj.content)
        let img = new Image()
        img.src = obj.icon || ''
        let contentWidth = this.ctx1.measureText(content).width
        let item = {
          content: content,
          x: this.bwm * this.barrageWidth,
          icon: obj.icon ? img : '',
          width: contentWidth + this.ibr * 2 + this.rpli + this.rpr,
          color: obj.color || '#2F2F2F',
          identifyName: obj.identifyName,
        }
        this.barrageArray.unshift(item)
      },
      /**
       * 处理字符
       */
      dealStr (str) {
        return str.length > 20 ? `${str.substring(0, 20)}...` : str
      },
      /**
       * 获取随机颜色
       */
      getColor () {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`
      },
      /**
       * 裁剪图片
       * @param ctx
       * @param img
       * @param x
       * @param y
       * @param r
       */
      circleBorder (ctx, img, x, y, rb, r) {
        /**
         * x: 原点x
         * y: 原点y
         * rb: 背景大圆radius
         * r: icon 小圆radius
         */
        try {
          let cx = x + rb
          let cy = y + this.rH / 2
          // 大圆边框
          ctx.save()
          ctx.strokeStyle = this.borderColor
          ctx.beginPath()
          ctx.arc(cx, cy, rb, 0, 2 * Math.PI)
          ctx.stroke()
          ctx.restore()
          ctx.closePath()
        } catch (e) {
          console.log(e)
        }
      },
      circleImg (ctx, img, x, y, rb, r) {
        /**
         * x: 原点x
         * y: 原点y
         * rb: 背景大圆radius
         * r: icon 小圆radius
         */
        try {
          let d = 2 * r
          let cx = x + rb
          let cy = y + this.rH / 2
          ctx.fillStyle = '#fff'
          // 大圆白色背景
          ctx.save()
          ctx.beginPath()
          ctx.arc(cx, cy, rb, 0, 2 * Math.PI)
          ctx.fill()
          ctx.restore()
          ctx.closePath()

          // 小圆图片裁剪
          ctx.save()
          ctx.beginPath()
          ctx.arc(cx, cy, r, 0, 2 * Math.PI)
          ctx.fill()
          ctx.clip()
          ctx.drawImage(img, cx - r, cy - r, d, d)
          ctx.restore()
          ctx.closePath()
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * 绘画圆角矩形
       * @param context
       * @param x
       * @param y
       * @param width
       * @param height
       * @param radius
       */
      drawRoundRect (context, x, y, width, height, radius, color) {
        if(color){
          context.fillStyle = color
        } else if (this.linearGradient.startColor && this.linearGradient.endColor) {
          let linearGrad = context.createLinearGradient(x, y, x, y + height)
          linearGrad.addColorStop(0, this.linearGradient.startColor)
          linearGrad.addColorStop(1, this.linearGradient.endColor)
          context.fillStyle = linearGrad
        } else {
          context.fillStyle = this.background
        }
        context.beginPath()
        context.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2)
        context.lineTo(width - radius + x, y)
        context.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2)
        context.lineTo(width + x, height + y - radius)
        context.arc(width - radius + x, height - radius + y, radius, 0, Math.PI / 2)
        context.lineTo(radius + x, height + y)
        context.arc(radius + x, height - radius + y, radius, Math.PI / 2, Math.PI)
        context.fill()
        context.closePath()
      },
      /**
       * 绘画圆角矩形
       * @param context
       * @param x
       * @param y
       * @param width
       * @param height
       * @param radius 半径
       */
      drawRoundRectBorder (context, x, y, width, height, radius) {
        context.beginPath()
        context.lineWidth = 2
        context.strokeStyle = this.borderColor
        context.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2)
        context.lineTo(width - radius + x, y)
        context.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2)
        context.lineTo(width + x, height + y - radius)
        context.arc(width - radius + x, height - radius + y, radius, 0, Math.PI / 2)
        context.lineTo(radius + x, height + y)
        context.arc(radius + x, height - radius + y, radius, Math.PI / 2, Math.PI)
        context.stroke()
        context.closePath()
      },
      /**
       * 绘制皇冠和身份
       */
      drawIdentify (ctx, identifyName, x, y) {
        try {
          // 皇冠
          ctx.save()
          ctx.beginPath()
          ctx.drawImage(this.crownImg, x + 44, y - 26, 30, 24)
          ctx.restore()

          // 身份背景
          this.drawRoundRect(ctx, x + 12, y + this.rH + 1, 56, 20, 10, '#F65676')

          // 身份
          ctx.save()
          ctx.beginPath()
          ctx.fillStyle = '#fff'
          ctx.font = '14px Microsoft YaHei',
          this.ctx.fillText(identifyName, x + 26, y + this.rH + 16)
          ctx.restore()
          ctx.closePath()

        } catch (e) {
          console.log(e)
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .canvas1 {
    position: absolute;
    left: 0;
  }
  .barrage-container {
    pointer-events: none;
  }
  .container {
    /*padding-top: 20px;*/
    width: 100%;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/barrage.vue